<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-2">
        <div class="btn btn-sm btn-secondary btn-block mr-1 mb-3 text-white" @click="backToSearch">
          <i class="fe fe-arrow-left"></i>Torna al motore di ricerca di Casino2k
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <template v-for="casino of $store.getters.compare">
        <CasinoCompareItem v-bind:casino="casino" v-bind:key="casino.id" />
      </template>
      <template v-for="slot of (isMobile() ? 2 :3) - $store.getters.compare.length">
        <CasinoCompareSlot v-bind:slot="slot" v-bind:key="slot" />
      </template>
    </div>

    <div class="row">
      <div class="col-12 pb-1 font-size-sm font-weight-bold mb-5 border-bottom mt-5">
        Aggiungi altri casinò al confronto
      </div>
          <div v-for="result of results" v-bind:key="'res' + '_' + result.id" class="col-4 col-sm-2 p-1 mb-1">
            <div class="card border">
            <div class="card-body p-1">
            <div v-if="$store.getters.compare.length < (isMobile() ? 2 :3)" @click="addToCompare(result)" class="add-list shadow">
              <i class="fe fe-plus"></i>
            </div>
              <img class="img-fluid" :src="'https://img.casino2k.com/' + result.logo" />
            </div>
            </div>
          </div> 
    </div>
  </div>
</template>

<script>
  import store from '../store';
  import CasinoCompareItem from './CasinoCompareItem';
  import CasinoCompareSlot from './CasinoCompareSlot';

  export default {
    name: 'Compare',
    components: {
      CasinoCompareItem,
      CasinoCompareSlot
    },
    methods: {
      backToSearch: () => {
        store.commit('setComparisonMode', false);
        window.scrollTo(0,0);
      },
      isMobile() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      },
      formatResults: (results) => {
        const formattedResults = [];
        for (let result of results) {
          const newObj = {
            ...result.casino,
            ...result.managedDomainInfo,
            ...result.countryInfo.find((e) => e.country.id == 1),
            visible: true,
            compared: false,
          };

          formattedResults.push(newObj);
        }

        return formattedResults;
      },
      scrollToTop() {
        window.scrollTo(0,0);
      },
      addToCompare(casino) {
        store.getters.compare.push(casino);
        store.getters.results.find((e) => e.id == casino.id).compared = true;
        this.results = this.results.filter((e) => e.id !== casino.id);
      },
    },
    data: function() {
      return {
        results: [],
      };
    },
    props: [],
    store,
    watch: {},
    async mounted() {
      this.scrollToTop();
      let res = await fetch(
        'https://2kadmin.casino2k.com/api/casinos/1?country=Italia', {
          method: 'GET',
          headers: {
            'Bearer-Token': 'yb5J12AEAlaEjlIC',
          },
        }
      );
      const comparedIds = store.getters.compare.map((e) => e.id);
      this.results = this.formatResults(await res.json()).filter(
        (e) => !comparedIds.includes(e.id) && e.attivo && e.sponsorizzabile && e.elencato
      );
      this.scrollToTop();

    },
  };
</script>